import { cn } from '@/lib/cn';

export interface SpinnerProps {
  /** Rendered size in pixels. */
  size?: number;
  className?: string;
  /** Announced to screen readers while the spinner is visible. */
  label?: string;
}

/**
 * Indeterminate progress. Uses `currentColor`, so it inherits the colour of
 * whatever it sits inside - including a primary button.
 */
export function Spinner({ size = 16, className, label }: SpinnerProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={cn('shrink-0 animate-spin', className)}
      role={label ? 'status' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
    >
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2.5" opacity="0.2" />
      <path
        d="M21 12a9 9 0 0 0-9-9"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
    </svg>
  );
}
